import { reactive } from 'vue'

export const uiState = reactive({
    locationSearchOpen: false,
    mainMenuOpen: false
})
